import {
  OPEN_VIEW_PAYLOAD_MODAL,
  CLOSE_VIEW_PAYLOAD_MODAL,
  SET_DATA_VIEW_PAYLOAD,
} from './ViewPayloadModalConstant';

const INITITAL_STATE = {
  isModalActive: false,
  modalHeader: '',
  data: {},
};

export function ViewPayloadModalReducer(state = INITITAL_STATE, action) {
  switch (action.type) {
    case OPEN_VIEW_PAYLOAD_MODAL: {
      return {
        ...state,
        isModalActive: true,
      };
    }
    case CLOSE_VIEW_PAYLOAD_MODAL: {
      return {
        ...state,
        isModalActive: false,
      };
    }
    case SET_DATA_VIEW_PAYLOAD: {
      return {
        ...state,
        data: action.data,
      }
    }
    default:
      return state;
  }
}
